import { isBrowser } from './config';

import type { ServerStampedHeaders } from './types';

const nullStamped: ServerStampedHeaders = {
  apiBase: null,
  tenantId: null,
  origin: null,
  forwardedProto: null,
  host: null,
};

export const getServerStampedHeaders =
  async (): Promise<ServerStampedHeaders> => {
    if (isBrowser()) return nullStamped;

    try {
      const { headers } = await import('next/headers');
      const h = await headers();

      const apiBase = h.get('x-api-base');
      const explicitTenantId = h.get('x-tenant-id');

      const host =
        h.get('x-viewer-host') ??
        h.get('x-original-host') ??
        h.get('x-forwarded-host') ??
        h.get('host');

      const forwardedProto = h.get('x-forwarded-proto');
      const referer = h.get('referer');

      let tenantId: string | null = explicitTenantId ?? null;

      // fallback: derive tenant id from host
      if (!tenantId && host) {
        try {
          const { resolveTenantIdFromHost } = await import('@/lib/tenants');
          tenantId = resolveTenantIdFromHost(host) ?? null;
        } catch {
          tenantId = null;
        }
      }

      const origin =
        (host && forwardedProto ? `${forwardedProto}://${host}` : null) ??
        (referer ? new URL(referer).origin : null) ??
        process.env.NEXT_PUBLIC_FRONTEND_URL ??
        null;

      return {
        apiBase: apiBase ?? null,
        tenantId,
        origin,
        forwardedProto: forwardedProto ?? null,
        host: host ?? null,
      };
    } catch {
      return nullStamped;
    }
  };
